import { MUTATION_KEYS, QUERY_KEYS, LOCIZE_NS } from '@avanta/shared/constants/common';
import { useMutation, type UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { AppointmentService } from 'services/appointments';
import { type CancelAppointmentPayload } from 'types/appointments';

export const useCancelAppointment = (
  appointmentId: string
): UseMutationResult<void, Error, CancelAppointmentPayload> => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  return useMutation<void, Error, CancelAppointmentPayload>({
    mutationKey: [MUTATION_KEYS.CANCEL_APPOINTMENT, appointmentId],
    mutationFn: async (body: CancelAppointmentPayload) => {
      await AppointmentService.cancel(body);
    },
    onSuccess: () => {
      toast.success(t('CancelAppointment.success'));
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FETCH_NEXT_APPOINTMENTS] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FETCH_ENTERPRISE_APPOINTMENTS] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FETCH_COUPONS] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FETCH_PATIENT] });
    },
    onError: () => {
      toast.error(t('CancelAppointment.error'));
    },
  });
};
